export default "__VITE_ASSET__ymA45N15__"